import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Skeleton } from '@/components/ui/skeleton'
import { toastFailure } from '@/lib/feedback'
import { toast } from '@/lib/toast'
import { CrmApiError } from '../http'
import { listByEvent } from './api'

/**
 * An old event address (`/relaties/events/:eventId`): events are lists now (spec-63 E5), so this
 * finds the list of the event and replaces itself with it. An unknown event lands on the lists.
 */
export function EventRedirect() {
  const { eventId } = useParams<{ eventId: string }>()
  const navigate = useNavigate()
  useEffect(() => {
    if (!eventId) return
    let cancelled = false
    listByEvent(eventId).then(
      ({ list_id }) => {
        if (!cancelled) void navigate(`/relaties/lijsten/${list_id}`, { replace: true })
      },
      (caught: unknown) => {
        if (cancelled) return
        if (caught instanceof CrmApiError && caught.status === 404) toast.error('Dit event bestaat niet meer.')
        else toastFailure(caught, 'Het event openen mislukt.')
        void navigate('/relaties/lijsten', { replace: true })
      },
    )
    return () => {
      cancelled = true
    }
  }, [eventId, navigate])
  return (
    <div className="flex flex-col gap-2" aria-hidden>
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  )
}
